import { h, Component } from 'preact';
import { getManageTicketsUrl } from 'helpers/tickets';
import QRCode from 'qrcode';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/ticketArea/desktopScan.sss';

export default class DesktopScan extends Component {

	async componentDidMount() {
		const qrCode = await QRCode.toCanvas(getManageTicketsUrl());
		this.$qrCodeContainer.appendChild(qrCode);
	}

	getNumButtons(buttons) {
		if (!buttons) return 0;
		const desktopButtons = buttons.children.filter((button) => button?.nodeName?.name === 'TicketAreaButton');
		return desktopButtons.length;
	}

	render({ copy, buttons }) {
		const numButtons = this.getNumButtons(buttons);
		return (
			<div class={s.container}>
				<h3 class={s.header}>{copy.$YOUR_TICKET}</h3>
				<div class={joinClasses(s.scanInstructions, numButtons > 2 && s.manyButtons)}>
					<div class={s.qrCodeContainer} ref={($ref) => this.$qrCodeContainer = $ref}>
						<div class={s.dummyQr} />
					</div>
					<span>{copy.$SCAN_TO_ADD_MOBILE_WALLET}</span>
				</div>
				{buttons}
			</div>
		);
	}
}